module.exports = __webpack_public_path__ + "img/horizontal_3_5_3009.7c9acadf.png";